// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import srchsynEntity from './entities/srchsyn.json';
import srchsynMenu from '../pages/srchsyn/menu.json';
import srchsynFullForm from '../pages/srchsyn/forms/full.json';
import srchsynContextForm from '../pages/srchsyn/forms/context.json';
import srchsynMiniForm from '../pages/srchsyn/forms/mini.json';
import srchsynLookupForm from '../pages/srchsyn/forms/lookup.json';
import srchsynTableView from '../pages/srchsyn/views/table.json';
import srchsynStagesView from '../pages/srchsyn/views/stages.json';
import srchsynCardsView from '../pages/srchsyn/views/cards.json';
import srchsynInlineView from '../pages/srchsyn/views/inline.json';
import srchsynBacklogView from '../pages/srchsyn/views/backlog.json';
import srchsynSplitView from '../pages/srchsyn/views/split.json';
import srchsynCalendarView from '../pages/srchsyn/views/calendar.json';
import srchsynDashboardView from '../pages/srchsyn/views/dashboard.json';

/** Тип запису «Синонім» зі сторінками пакета: меню, форми та подання з pages/srchsyn/. */
export const srchsynDefinition: IRecordTypeDefinition = {
  ...srchsynEntity,
  views: assembleViewSet({
      table: srchsynTableView,
      stages: srchsynStagesView,
      cards: srchsynCardsView,
      inline: srchsynInlineView,
      backlog: srchsynBacklogView,
      split: srchsynSplitView,
      calendar: srchsynCalendarView,
      dashboard: srchsynDashboardView,
  }),
  form: srchsynFullForm,
  forms: { full: srchsynFullForm, context: srchsynContextForm, mini: srchsynMiniForm, lookup: srchsynLookupForm },
  menu: srchsynMenu,
} as IRecordTypeDefinition;
